import { INVITE_USER, LOGIN_TIME_LINE_REPORT, PORTAL_DROPDOWN, REMOVE_PORTAL, USER_DELETE, USER_EDIT, USER_LIST, USER_VIEW } from "./types";

export const userList = (data, onSuccess, onError) => {
    return {
        type: USER_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const inviteUser = (data, onSuccess, onError) => {
    return {
        type: INVITE_USER,
        data,
        onSuccess,
        onError,
    };
};

export const portalsDropDown = (onSuccess, onError) => {
    return {
        type: PORTAL_DROPDOWN,
        onSuccess,
        onError,
    };
};

export const userView = (id, onSuccess, onError) => {
    return {
        type: USER_VIEW,
        id,
        onSuccess,
        onError,
    };
};

export const userEdit = (data, onSuccess, onError) => {
    return {
        type: USER_EDIT,
        data,
        onSuccess,
        onError,
    };
};


export const userDelete = (data, onSuccess, onError) => {
    return {
        type: USER_DELETE,
        data,
        onSuccess,
        onError,
    };
};


export const getLoginReport = (id, onSuccess, onError) => {
    return {
        type: LOGIN_TIME_LINE_REPORT,
        id,
        onSuccess,
        onError,
    };
};

export const removePortal = (data, onSuccess, onError) => {
    return {
        type: REMOVE_PORTAL,
        data,
        onSuccess,
        onError,
    };
};